import {defineAsyncComponent} from 'vue';

const ReportPrintPreview = defineAsyncComponent(() => import('@/views/report/ReportPrintPreview.vue'));
const StaticReportPrintPreview = defineAsyncComponent(() => import('@/views/report/StaticReportPrintPreview.vue'));
const StaticReportPrintPreviewSync = defineAsyncComponent(() =>
  import('@/views/report/reportSyncPreview/StaticReportPrintPreviewSync.vue'),
);
const VoucherReportPrintPreview = defineAsyncComponent(() => import('@/views/report/VoucherReportPrintPreview.vue'));
const VoucherReportPrintPreviewSync = defineAsyncComponent(() =>
  import('@/views/report/reportSyncPreview/VoucherReportPrintPreviewSync.vue'),
);
const DynamicReportPrintPreview = defineAsyncComponent(() => import('@/views/report/DynamicReportPrintPreview.vue'));
const DynamicReportPrintPreviewSync = defineAsyncComponent(() =>
  import('@/views/report/reportSyncPreview/DynamicReportPrintPreviewSync.vue'),
);
const DemoReportPrintPreview = defineAsyncComponent(() => import('@/views/report/DemoReportPrintPreview.vue'));
const C203NSND11 = defineAsyncComponent(() => import('@/views/report/voucherReport/c203NS/C203NSND11ParamPopup.vue'));
const ReportParamDemo = defineAsyncComponent(() => import('@/views/report/voucherReport/report_param_demo.vue'));
const ReportParamCommuneBudget = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParamCommuneBudget.vue'),
);

const DebtVoucherPreview = defineAsyncComponent(() => import('@/views/report/DebtVoucherPreview.vue'));
const ReportParamS18X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ConstructionBudget/S18X/ReportParamS18X.vue'),
);
const ReportParamTT3422016_B64_65 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/communeReport/ReportParamTT3422016_B64_65.vue'),
);
const ReportSDKP_DVDT_B01 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportTreasury/ReportParam_SDKP_DVDT_B01.vue'),
);

const ReportParam_BCKB_01b = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportTreasury/ReportParam_BCKB_01b.vue'),
);

const ReportSDKP_DVDT_B01a = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportTreasury/ReportParam_SDKP_DVDT_B01a.vue'),
);
const ReportParamCompareUseBudget = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ReportParamCompareUseBudget.vue'),
);
const ReportParamCompareUseBudgetB02a = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportTreasury/ReportParamCompareUseBudgetB02a.vue'),
);

const ShowReports = defineAsyncComponent(() => import('@/views/report/ShowReports.vue'));
const reportParamBCTCB01X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/financialReport/ReportParam_BCTC_B01X.vue'),
);
const reportParamBCTCB06X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/financialReport/reportParamBCTCB06X/ReportParamBCTCB06X.vue'),
);

const reportParam_BCTC_C03CCTT = defineAsyncComponent(() =>
  import('@/views/report/staticReport/financialReport/reportParam_BCTC_C03CCTT.vue'),
);
// Nhật ký - sổ cái
const ReportLedgerLog_S01X = defineAsyncComponent(() => import('@/views/report/ledgerReport/ReportLedgerLog_S01X.vue'));

// Sổ cái
const ReportLedgerLog_S01bX = defineAsyncComponent(() =>
  import('@/views/report/ledgerReport/ReportLedgerLog_S01bX.vue'),
);

//Các loại sổ khác
const reportParamS04Vertical = defineAsyncComponent(() =>
  import('@/views/report/staticReport/activityLedgerReport/ReportParamS04Vertical.vue'),
);
const reportParamS04aXUnitItem = defineAsyncComponent(() =>
  import('@/views/report/staticReport/activityLedgerReport/ReportParamS04aXUnitItem.vue'),
);
const reportParamS04aXTT70 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/activityLedgerReport/ReportParamS04aXTT70.vue'),
);
//Các loại sổ khác
const reportParamC43_X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ortherLedger/C43X/ReportParamC43X.vue'),
);
const reportParamS13_X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ortherLedger/S13X/ReportParamS13X.vue'),
);
const reportParamS15_X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/ortherLedger/S15X/ReportParamS15X.vue'),
);
const reportParam_s10x = defineAsyncComponent(() =>
  import('@/views/report/staticReport/paymentAndReceiptReport/s10-x/ReportParam_s10x.vue'),
);
const reportParamS08X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/paymentAndReceiptReport/s08-x/ReportParam_s08x.vue'),
);
const reportParamS09X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/paymentAndReceiptReport/s09-x/ReportParam_s09x.vue'),
);
const reportParamS04bX = defineAsyncComponent(() =>
  import('@/views/report/staticReport/activityLedgerReport/ReportParamS04bX.vue'),
);
// Sổ chuyên dùng cho các hoạt động của xã
const ReportParam_S05b_X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/communeLedgerReport/communeLedgerReport_S05b_X/ReportParam_S05b_X.vue'),
);
const ReportParam_S07_X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/communeLedgerReport/communeLedgerReport_S07_X/ReportParam_S07_X.vue'),
);

const ReportParam_S07_X_Year = defineAsyncComponent(() =>
  import('@/views/report/staticReport/communeLedgerReport/communeLedgerReport_S07_X_Year/ReportParam_S07_X_Year.vue'),
);

const ReportParam_38_CKTC_NSX = defineAsyncComponent(() =>
  import('@/views/report/staticReport/communeLedgerReport/reportParam_38_CKTC_NSX/ReportParam_38_CKTC_NSX.vue'),
);

const ReportParamB59 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/communeReport/ReportParamB59.vue'),
);
const ReportParamB58 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/communeReport/ReportParamB58.vue'),
);

// form tham số của biểu số 15 C9217
const popupC9217TT64 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/15_QTDA_TT64(C9217)/VoucherReportC9217_TT64.vue'),
);

// form tham số của biểu số 16 C10432
const popuptC10432TT64 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/16_QTDA_TT64(C10432)/VoucherReportC10432_TT64.vue'),
);

const reportParam_TT342_626364 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportCommune/ReportParam_TT342_626364.vue'),
);
const reportParamS05Vertical = defineAsyncComponent(() =>
  import('@/views/report/staticReport/activityLedgerReport/ReportParamS05Vertical.vue'),
);
const reportParamS05Itt = defineAsyncComponent(() =>
  import('@/views/report/staticReport/activityLedgerReport/ReportParamS05Itt.vue'),
);
const reportParamS05TT70 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/activityLedgerReport/ReportParamS05TT70.vue'),
);

const PaymentVoucherListPrintFromVoucher_ND11_2020 = defineAsyncComponent(() =>
  import(
    '@/views/report/voucherReport/PaymentVoucherListPrintFromVoucher_ND11_2020/PaymentVoucherListPrintFromVoucher_ND11_2020.vue'
  ),
);

const PaymentVoucherListPrintFromVoucher_tt344_2016 = defineAsyncComponent(() =>
  import(
    '@/views/report/voucherReport/PaymentVoucherListPrintFromVoucher_tt344_2016/PaymentVoucherListPrintFromVoucher_tt344_2016.vue'
  ),
);

const PaymentVoucherListPrintFromVoucher_ND11_2020_Vertical = defineAsyncComponent(() =>
  import(
    '@/views/report/voucherReport/PaymentVoucherListPrintFromVoucher_ND11_2020/PaymentVoucherListPrintFromVoucher_ND11_2020_Vertical.vue'
  ),
);

const CTG_Payment = defineAsyncComponent(() => import('@/views/report/voucherReport/CTG_Payment/CTG_Payment.vue'));

const PaymentVoucher_BTC_tt344_2016 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/PaymentVoucher_BTC_tt344_2016/PaymentVoucher_BTC_tt344_2016.vue'),
);

// báo cáo ngân sách xã
const reportParam_TT3442016_B05 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportCommune/reportParam_B05_TT344/ReportParam_TT3442016_B05.vue'),
);
const reportParam_TT3442016_B07 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportCommune/reportParam_B07_TT344/ReportParam_TT3442016_B07.vue'),
);

//Báo cáo 01x Bảng cân đối tài khoản
const reportParamAccountBalaceB01X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/financialReport/ReportParamAccountBalaceB01X.vue'),
);
const reportParamAccountBalaceMLNS = defineAsyncComponent(() =>
  import('@/views/report/staticReport/financialReport/ReportParamAccountBalaceMLNS.vue'),
);
const ReportParam05TT = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/ReportParam05TT/ReportParam05TT.vue'),
);

const reportParamS02bX = defineAsyncComponent(() =>
  import('@/views/report/staticReport/cashReport/S02b-X/ReportParam_S02b-X.vue'),
);

const reportParam_SDKP_DVDT_B02b = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportTreasury/ReportParam_SDKP_DVDT_B02b.vue'),
);

const reportParam_SDKP_DVDT_B04 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportTreasury/ReportParam_SDKP_DVDT_B04.vue'),
);

const reportParam_06_DCSDTK_KBNN = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportTreasury/reportParam_06_DCSDTK_KBNN/ReportParam_06_DCSDTK_KBNN.vue'),
);

//Công cụ, dụng cụ
const reportParamS21X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/inventoryReport/s21x/ReportParamS21X.vue'),
);

const reportParamS02aX = defineAsyncComponent(() =>
  import('@/views/report/staticReport/cashReport/S02a-X/ReportParam_S02a-X.vue'),
);

const reportParamS03X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/cashReport/S03-X/ReportParam_S03-X.vue'),
);

const reportParamS11H = defineAsyncComponent(() =>
  import('@/views/report/staticReport/cashReport/S11-H/ReportParam_S11-H.vue'),
);

const S11XTSCD = defineAsyncComponent(() =>
  import('@/views/report/staticReport/inventoryReport/S11XTSCD/S11XTSCD.vue'),
);

//Báo cáo chứng từ
const PlanReceiptByBudgetListReport = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/planReceiptByBudgetListReport/PlanReceiptByBudgetListReport.vue'),
);

//tổng hợp công nợ
const tongHopCongNo = defineAsyncComponent(() => import('@/views/report/staticReport/tongHopCongNo/TongHopCongNo.vue'));

const reportParam_S06b_X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/communeLedgerReport/reportParam_B06/ReportParam_S06b_X.vue'),
);

const reportParam_S06b_X_Horizontal = defineAsyncComponent(() =>
  import('@/views/report/staticReport/communeLedgerReport/reportParam_B06/ReportParam_S06b_X_Horizontal.vue'),
);

// Các báo cáo vật tư, vật liệu
const ReportParamBS19X = defineAsyncComponent(() =>
  import('@/views/report/staticReport/inventoryReport/bs19x/ReportParamBS19X.vue'),
);
const reportParamBalanceBudget = defineAsyncComponent(() =>
  import('@/views/report/staticReport/publicReport/ReportParamBalanceBudget.vue'),
);

//Báo cáo S06a-X Sổ tổng hợp thu ngân sách xã
const reportBookForCommunalActivitiesS06aX = defineAsyncComponent(() =>
  import('@/views/report/staticReport/bookForCommunalActivitiesReport/ReportBookForCommunalActivitiesS06aX.vue'),
);

// Báo cáo công cụ dụng cụ
const ReportParamS32H = defineAsyncComponent(() =>
  import('@/views/report/staticReport/toolReport/s32h/ReportParamS32H.vue'),
);

const InventoryReport_stock_remain = defineAsyncComponent(() =>
  import('@/views/report/staticReport/toolReport/inventoryReport_stock_remain/InventoryReport_stock_remain.vue'),
);

//Báo cáo đặc thù
const CustomReport_PTC_4 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/customReport/customReport_PTC_4/CustomReport_PTC_4.vue'),
);
const reportCompareWithdrawAndSpend = defineAsyncComponent(() =>
  import('@/views/report/staticReport/specialReport/ReportCompareWithdrawAndSpend.vue'),
);
const reportParamCompareWithdrawAndPayment = defineAsyncComponent(() =>
  import('@/views/report/staticReport/customReport/compareWithdrawAndPayment/ReportParamCompareWithdrawAndPayment.vue'),
);
const reportParamCompareWithdrawAndPaymentMLNS = defineAsyncComponent(() =>
  import(
    '@/views/report/staticReport/customReport/compareWithdrawAndPayment/ReportParamCompareWithdrawAndPaymentMLNS.vue'
  ),
);

// form tham số báo cáo Sổ theo dõi các khoản rút dự toán - PBI 72163
const reportParamVoucherWithdrawMonitor = defineAsyncComponent(() =>
  import('@/views/report/specialReport/reportVoucherWithdrawMonitor/ReportVoucherWithdrawMonitor.vue'),
);

const ReportParamS20X = defineAsyncComponent(() => import('@/views/report/staticReport/s20x/Report_param_s20x.vue'));

const ReportParamC53HD = defineAsyncComponent(() => import('@/views/report/staticReport/C53HD/ReportParamC53HD.vue'));

const ExpenseBudgetTreasuryTB_param = defineAsyncComponent(() =>
  import('@/views/report/specificReport/expenseBudgetTreasury/ExpenseBudgetTreasuryTB_param.vue'),
);

const voucherReportC201a_TT19 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/C201a_TT19/VoucherReportC201a_TT19.vue'),
);

const popupC205bTT192020 = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/c205b_TT192020/C205b_TT192020.vue'),
);
const voucherReportLctKck = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/Lct_Kck/VoucherReportLctKck.vue'),
);
const voucherReportLctLtm = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/Lct_Ltm/VoucherReportLctLtm.vue'),
);

const reportParamSpecial = defineAsyncComponent(() => import('@/views/report/specialReport/ReportParamSpecial.vue'));

const buExpense_GRT_CKKB_BKCTTC = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/buExpense_GRT_CKKB_BKCTTC/BUExpense_GRT_CKKB_BKCTTC.vue'),
);
// Sổ chi tiết đối chiếu số rút và chi
const reportParamCompareSpending = defineAsyncComponent(() =>
  import('@/views/report/specialReport/reportCompareSpending/ReportParamCompareSpending.vue'),
);

// Báo cáo tổng hợp chi ngân sách xã theo nội dung kinh tế (B02b-X) (mẫu tổng hợp theo nguồn)
const reportParamB02bX = defineAsyncComponent(() =>
  import('@/views/report/specialReport/reportParamB02bX/ReportParamB02bX.vue'),
);

const reportParamPleiku = defineAsyncComponent(() =>
  import('@/views/report/specialReport/reportParamPleiku/ReportParamPleiku.vue'),
);

const reportTreasuryAdvance = defineAsyncComponent(() =>
  import('@/views/report/specialReport/reportTreasuryAdvance/ReportTreasuryAdvance.vue'),
);

const reportTreasuryAdvanceVoucher = defineAsyncComponent(() =>
  import('@/views/report/specialReport/reportTreasuryAdvanceVoucher/ReportTreasuryAdvanceVoucher.vue'),
);

const reportParamBKCTT_PTC = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportParamBTCTT_PTC/ReportParamBKCTT.vue'),
);
const reportParamBKCTC_PTC = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportParamBTCTC_PTC/ReportParamBKCTC.vue'),
);

const GRC2_11_NS = defineAsyncComponent(() => import('@/views/report/voucherReport/c211_TT192020/c211_TT192020.vue'));

const C210_TT19 = defineAsyncComponent(() => import('@/views/report/voucherReport/c210_tt19/c210_tt19.vue'));

//Báo cáo kho bạc B03
const reportReportParamSDKPDVDTB03 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportTreasury/reportParamSDKPDVDTB03/ReportParamSDKPDVDTB03.vue'),
);

const reportParam_s22x = defineAsyncComponent(() =>
  import('@/views/report/staticReport/reportTreasury/reportParam_s22x/reportParam_s22x.vue'),
);

//  Form tham số Biểu số 14/QTDA: Báo cáo quyết toán vốn đầu tư dự án hoàn thành (TT số 96/2021/TT-BTC )
const reportParam_B14_QTDA = defineAsyncComponent(() =>
  import('@/views/report/fundamentalConstruction/ReportParam_B14_QTDA.vue'),
);

//  Form tham số Biểu số 15/QTDA: Bảng đối chiếu số liệu (TT số 96/2021/TT-BTC )
const reportParam_B15_QTDA = defineAsyncComponent(() =>
  import('@/views/report/fundamentalConstruction/ReportParam_B15_QTDA.vue'),
);

//Xây dựng cơ bản
const reportParamB01KHDT = defineAsyncComponent(() =>
  import('@/views/report/staticReport/basicConstruction/reportParamB01KHDT/reportParamB01KHDT.vue'),
);
const reportParam_B03 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/baseContruction/ReportParam_B03/ReportParam_B03.vue'),
);

// Báo cáo nghị định 31
const ReportParam_TT312017_ND31 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/bcnd31/ReportParam_TT312017_ND31.vue'),
);
const ReportParam_TT312017_ND31_B54 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/bcnd31/ReportParam_TT312017_ND31_B54.vue'),
);
const ReportParam_TT312017_ND31_B62 = defineAsyncComponent(() =>
  import('@/views/report/staticReport/bcnd31/ReportParam_TT312017_ND31_B62.vue'),
);
// Thiết kế bìa sổ
const coverDesign = defineAsyncComponent(() => import('@/views/report/coverDesign/CoverDesign.vue'));

const VoucherReportC37HD = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/C37HD/VoucherReportC37HD.vue'),
);

// Thiết kế mẫu C37HD
const templateDesignFormC37HD = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/voucher/templateDesignFormC37HD/TemplateDesignFormC37HD.vue'),
);

// Thiết kế mẫu C2_11
const templateDesignFormC2_11 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/voucher/templateDesignFormC2_11/TemplateDesignFormC2_11.vue'),
);

// Thiết kế mẫu phiếu thu chi 2 liên
const templateDesignFormC40_C41 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/voucher/templateDesignFormC40_C41/TemplateDesignFormC40_C41.vue'),
);

// Form lưu mẫu mới thiết kế chân chữ ký
const popupSaveNewDesignTemplate = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/PopupSaveNewDesignTemplate.vue'),
);

// Thiết kế mẫu B07
const templateDesignFormB07 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB07/TemplateDesignFormB07.vue'),
);

// Thiết kế mẫu B62
const templateDesignForm_B62 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignForm_B62/TemplateDesignForm_B62.vue'),
);

// Thiết kế mẫu B118
const templateDesignFormB118 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB118/TemplateDesignFormB118.vue'),
);

// Thiết kế mẫu B13
const templateDesignFormB13 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB13/TemplateDesignFormB13.vue'),
);

// Thiết kế mẫu B58
const templateDesignFormB58 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB58/TemplateDesignFormB58.vue'),
);

// Thiết kế mẫu B12
const templateDesignFormB12 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB12/TemplateDesignFormB12.vue'),
);

// Thiết kế mẫu B08
const templateDesignFormB08 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB08/TemplateDesignFormB08.vue'),
);

// Thiết kế mẫu B09
const templateDesignFormB09 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB09/TemplateDesignFormB09.vue'),
);

// Thiết kế mẫu
const templateDesignForm_10_11 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignForm_10_11/TemplateDesignForm_10_11.vue'),
);
const templateDesignFormS03X = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormS03X/TemplateDesignFormS03X.vue'),
);

// Thiết kế mẫu S02ax
const templateDesignFormS02ax = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormS02ax/TemplateDesignFormS02ax.vue'),
);

// Sửa chân chữ ký mẫu B62 B63 B64 B65
const templateDesignFormB62 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignForm_62_63_64_65/TemplateDesignForm_62.vue'),
);

// Thiết kế mẫu 59
const templateDesignForm59 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignForm59/TemplateDesignForm59.vue'),
);

// Thiết kế mẫu 60
const templateDesignForm60 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignForm60/TemplateDesignForm60.vue'),
);

// Thiết kế mẫu 61
const templateDesignForm61 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignForm61/TemplateDesignForm61.vue'),
);

const ReportParamC37 = defineAsyncComponent(() => import('@/views/report/voucherReport/C37HD/ReportParamC37.vue'));

const templateDesignFormB01 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB01/TemplateDesignFormB01.vue'),
);
const templateDesignFormB02 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB02/TemplateDesignFormB02.vue'),
);
const templateDesignFormB03 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB03/TemplateDesignFormB03.vue'),
);
const templateDesignFormB05 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB05/TemplateDesignFormB05.vue'),
);

const popupReportDepositOrderAgribank = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/reportDepositOrderAgribank/ReportDepositOrderAgribank.vue'),
);

const popupReportPaymentOrderAgribank = defineAsyncComponent(() =>
  import('@/views/report/voucherReport/reportPaymentOrderAgribank/ReportPaymentOrderAgribank.vue'),
);

const templateDesignFormReceipt = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/voucher/templateDesignFormReceipt/TemplateDesignFormReceipt.vue'),
);

const templateDesignFormReceiptMLNS = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/voucher/templateDesignFormReceiptMLNS/TemplateDesignFormReceiptMLNS.vue'),
);

// Thiết kế mẫu B103
const templateDesignForm103 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignForm103/TemplateDesignForm103.vue'),
);

// Thiết kế mẫu B105
const templateDesignForm105 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignForm105/TemplateDesignForm105.vue'),
);
// Thiết kế mẫu B113
const templateDesignFormB113 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB113/TemplateDesignFormB113.vue'),
);

// Thiết kế mẫu B114
const templateDesignFormB114 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB114/TemplateDesignFormB114.vue'),
);

// Thiết kế mẫu B115
const templateDesignFormB115 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB115/TemplateDesignFormB115.vue'),
);

// Thiết kế mẫu B116
const templateDesignFormB116 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB116/TemplateDesignFormB116.vue'),
);

// Thiết kế mẫu B117
const templateDesignFormB117 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/report/templateDesignFormB117/TemplateDesignFormB117.vue'),
);
const templateDesignFormC402 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/voucher/templateDesignFormC402/TemplateDesignFormC402.vue'),
);
const templateDesignFormC202 = defineAsyncComponent(() =>
  import('@/views/report/templateDesign/voucher/templateDesignFormC202/TemplateDesignFormC202.vue'),
);
const PaymentVoucherListExpensesPaid = defineAsyncComponent(() =>
  import(
    '@/views/report/voucherReport/paymentVoucherListExpensesPaid/PaymentVoucherListExpensesPaid.vue'
  ),
);
export function registerReport(app) {
  app.component('ShowReports', ShowReports);
  app.component('ReportPrintPreview', ReportPrintPreview);
  app.component('StaticReportPrintPreview', StaticReportPrintPreview);
  app.component('StaticReportPrintPreviewSync', StaticReportPrintPreviewSync);
  app.component('VoucherReportPrintPreview', VoucherReportPrintPreview);
  app.component('VoucherReportPrintPreviewSync', VoucherReportPrintPreviewSync);
  app.component('DynamicReportPrintPreview', DynamicReportPrintPreview);
  app.component('DynamicReportPrintPreviewSync', DynamicReportPrintPreviewSync);
  app.component('DemoReportPrintPreview', DemoReportPrintPreview);
  app.component('ReportDataParamDemo', ReportParamDemo);
  app.component('ReportParamCommuneBudget', ReportParamCommuneBudget);
  app.component('ReportParamS18X', ReportParamS18X);

  app.component('ReportParamCompareUseBudget', ReportParamCompareUseBudget);
  app.component('ReportParamTT3422016_B64_65', ReportParamTT3422016_B64_65);
  app.component('C203NSND11', C203NSND11);
  app.component('C205b_TT192020', popupC205bTT192020);
  // BCTC-B01X
  app.component('ReportParamBCTCB01X', reportParamBCTCB01X);
  app.component('ReportParamBCTCB06X', reportParamBCTCB06X);
  app.component('ReportParamC03CCTT', reportParam_BCTC_C03CCTT);

  app.component('ReportParam_SDKP_DVDT_B01', ReportSDKP_DVDT_B01);
  app.component('ReportParam_BCKB_01b', ReportParam_BCKB_01b);
  app.component('ReportParam_SDKP_DVDT_B01a', ReportSDKP_DVDT_B01a);
  app.component('ReportParamCompareUseBudgetB02a', ReportParamCompareUseBudgetB02a);
  app.component('PaymentVoucherListPrintFromVoucher_ND11_2020', PaymentVoucherListPrintFromVoucher_ND11_2020);
  app.component(
    'PaymentVoucherListPrintFromVoucher_ND11_2020_Vertical',
    PaymentVoucherListPrintFromVoucher_ND11_2020_Vertical,
  );

  app.component('CTG_Payment', CTG_Payment);

  app.component('PaymentVoucher_BTC_tt344_2016', PaymentVoucher_BTC_tt344_2016);
  app.component('PaymentVoucherListPrintFromVoucher_tt344_2016', PaymentVoucherListPrintFromVoucher_tt344_2016);
  app.component('ReportParam05TT', ReportParam05TT);
  app.component('ReportParamS04Vertical', reportParamS04Vertical);
  app.component('ReportParamS04aXUnitItem', reportParamS04aXUnitItem);
  app.component('ReportParamS04aXTT70', reportParamS04aXTT70);
  app.component('ReportLedgerLog_S01X', ReportLedgerLog_S01X);
  app.component('ReportLedgerLog_S01bX', ReportLedgerLog_S01bX);
  app.component('ReportParamC43_X', reportParamC43_X);
  app.component('ReportParamS13_X', reportParamS13_X);
  app.component('ReportParamS15_X', reportParamS15_X);
  app.component('ReportParamC9217TT64', popupC9217TT64);
  app.component('ReportParamC10432TT64', popuptC10432TT64);

  app.component('ReportParam_TT342_626364', reportParam_TT342_626364);

  //Công cụ dụng cụ
  app.component('ReportParamS21X', reportParamS21X);

  app.component('ReportParamAccountBalaceB01X', reportParamAccountBalaceB01X);
  app.component('ReportParamAccountBalaceMLNS', reportParamAccountBalaceMLNS);

  // Báo cáo tiền mặt, tiền gửi
  app.component('reportParamS02aX', reportParamS02aX);
  app.component('reportParamS02bX', reportParamS02bX);
  app.component('ReportParam_SDKP_DVDT_B02b', reportParam_SDKP_DVDT_B02b);
  app.component('ReportParamS04bX', reportParamS04bX);
  app.component('reportParamS03X', reportParamS03X);
  app.component('reportParamS11H', reportParamS11H);

  // Sổ chuyên dùng cho các hoạt động của xã
  app.component('ReportParam_S05b_X', ReportParam_S05b_X);
  app.component('ReportParam_S07_X', ReportParam_S07_X);
  app.component('ReportParam_S07_X_Year', ReportParam_S07_X_Year);

  app.component('ReportParam_38_CKTC_NSX', ReportParam_38_CKTC_NSX);

  app.component('ReportParamB59', ReportParamB59);
  app.component('ReportParamB58', ReportParamB58);

  app.component('reportParam_TT3442016_B05', reportParam_TT3442016_B05);
  app.component('reportParam_TT3442016_B07', reportParam_TT3442016_B07);
  app.component('ReportParam_SDKP_DVDT_B04', reportParam_SDKP_DVDT_B04);
  app.component('ReportParam_06_DCSDTK_KBNN', reportParam_06_DCSDTK_KBNN);
  app.component('ReportParamS05Vertical', reportParamS05Vertical);
  app.component('S11XTSCD', S11XTSCD);

  //Báo cáo chứng từ
  app.component('PlanReceiptByBudgetListReport', PlanReceiptByBudgetListReport);

  // Các báo cáo phải thu, phải trả
  app.component('reportParam_s10x', reportParam_s10x);
  app.component('reportParamS08X', reportParamS08X);
  app.component('reportParamS09X', reportParamS09X);

  // tổng hợp công nợ
  app.component('TongHopCongNo', tongHopCongNo);
  app.component('ReportParamBS19X', ReportParamBS19X);
  app.component('ReportParam_S06b_X', reportParam_S06b_X);
  app.component('ReportParamS32H', ReportParamS32H);
  app.component('ReportParamS05Itt', reportParamS05Itt);
  app.component('ReportParamS05TT70', reportParamS05TT70);
  app.component('ReportParamBalanceBudget', reportParamBalanceBudget);
  app.component('ReportBookForCommunalActivitiesS06aX', reportBookForCommunalActivitiesS06aX);

  // báo cáo vật tư, vật liệu
  app.component('Report_param_s20x', ReportParamS20X);

  // báo cáo tài sản cố định
  app.component('ReportParamC53HD', ReportParamC53HD);

  app.component('ReportParam_S06b_X_Horizontal', reportParam_S06b_X_Horizontal);
  app.component('ExpenseBudgetTreasuryTB_param', ExpenseBudgetTreasuryTB_param);

  // báo cáo đặc thù
  app.component('ReportCompareWithdrawAndSpend', reportCompareWithdrawAndSpend);
  app.component('reportParamCompareWithdrawAndPayment', reportParamCompareWithdrawAndPayment);
  app.component('reportParamCompareWithdrawAndPaymentMLNS', reportParamCompareWithdrawAndPaymentMLNS);
  app.component('CustomReport_PTC_4', CustomReport_PTC_4);
  app.component('VoucherReportC201a_TT19', voucherReportC201a_TT19);
  app.component('VoucherReportLctKck', voucherReportLctKck);
  app.component('ReportParamSpecial', reportParamSpecial);
  app.component('VoucherReportLctLtm', voucherReportLctLtm);
  app.component('ReportParamBKCTT', reportParamBKCTT_PTC);
  app.component('ReportParamBKCTC', reportParamBKCTC_PTC);
  // form tham số báo cáo Sổ theo dõi các khoản rút dự toán - PBI 72163
  app.component('ReportParamVoucherWithdrawMonitor', reportParamVoucherWithdrawMonitor);

  //Báo cáo tồn kho
  app.component('InventoryReport_stock_remain', InventoryReport_stock_remain);
  // Sổ chi tiết đối chiếu số rút và chi
  app.component('ReportParamCompareSpending', reportParamCompareSpending);
  app.component('ReportParamB02bX', reportParamB02bX);
  app.component('BUExpense_GRT_CKKB_BKCTTC', buExpense_GRT_CKKB_BKCTTC);
  app.component('ReportParamPleiku', reportParamPleiku);
  app.component('ReportTreasuryAdvance', reportTreasuryAdvance);
  app.component('ReportTreasuryAdvanceVoucher', reportTreasuryAdvanceVoucher);
  app.component('GRC2_11_NS', GRC2_11_NS);
  app.component('C210_TT19', C210_TT19);
  app.component('ReportParamSDKPDVDTB03', reportReportParamSDKPDVDTB03);
  app.component('reportParam_s22x', reportParam_s22x);
  //  Báo cáo Xây dựng cơ bản
  app.component('ReportParam_B15_QTDA', reportParam_B15_QTDA);
  app.component('ReportParam_B14_QTDA', reportParam_B14_QTDA);

  // Báo cáo nghị định 31
  app.component('ReportParam_TT312017_ND31', ReportParam_TT312017_ND31);
  app.component('ReportParam_TT312017_ND31_B54', ReportParam_TT312017_ND31_B54);
  app.component('ReportParam_TT312017_ND31_B62', ReportParam_TT312017_ND31_B62);

  //đăng kí kế hoạch vốn đầu tư thuộc ngân sách xã, phường, thị trấn
  app.component('reportParamB01KHDT', reportParamB01KHDT);
  app.component('ReportParam_B03', reportParam_B03);

  //Thiết kế bìa sổ
  app.component('CoverDesign', coverDesign);

  app.component('VoucherReportC37HD', VoucherReportC37HD);

  //Thiết kế mẫu C37HD
  app.component('TemplateDesignFormC37HD', templateDesignFormC37HD);

  //Thiết kế mẫu C2_11
  app.component('TemplateDesignFormC2_11', templateDesignFormC2_11);

  //Thiết kế mẫu phiếu thu chi 2 liên
  app.component('TemplateDesignFormC40_C41', templateDesignFormC40_C41);
  // Form lưu mẫu mới thiết kế chân chữ ký
  app.component('PopupSaveNewDesignTemplate', popupSaveNewDesignTemplate);
  //Thiết kế mẫu B08
  app.component('TemplateDesignFormB08', templateDesignFormB08);
  //Thiết kế mẫu B07
  app.component('TemplateDesignFormB07', templateDesignFormB07);
  //Thiết kế mẫu B13
  app.component('TemplateDesignFormB13', templateDesignFormB13);
  //Thiết kế mẫu B58
  app.component('TemplateDesignFormB58', templateDesignFormB58);
  //Thiết kế mẫu B12
  app.component('TemplateDesignFormB12', templateDesignFormB12);

  //Thiết kế mẫu B09
  app.component('TemplateDesignFormB09', templateDesignFormB09);
  app.component('TemplateDesignForm_10_11', templateDesignForm_10_11); // Chân chữ ký mẫu 10
  app.component('TemplateDesignFormS03X', templateDesignFormS03X);

  //Thiết kế mẫu S02ax
  app.component('TemplateDesignFormS02ax', templateDesignFormS02ax);
  app.component('DebtVoucherPreview', DebtVoucherPreview);
  app.component('ReportParamC37', ReportParamC37);

  //Thiết kế mẫu 59
  app.component('TemplateDesignForm59', templateDesignForm59);

  //Thiết kế mẫu 60
  app.component('TemplateDesignForm60', templateDesignForm60);

  //Thiết kế mẫu 61
  app.component('TemplateDesignForm61', templateDesignForm61);

  app.component('TemplateDesignFormB01', templateDesignFormB01);
  app.component('TemplateDesignFormB02', templateDesignFormB02);
  app.component('TemplateDesignFormB03', templateDesignFormB03);
  app.component('TemplateDesignFormB05', templateDesignFormB05);
  app.component('ReportDepositOrderAgribank', popupReportDepositOrderAgribank);
  app.component('ReportPaymentOrderAgribank', popupReportPaymentOrderAgribank);

  // Sửa chân chữ ký B62 B63 B64 B65
  app.component('TemplateDesignFormB62636465', templateDesignFormB62);

  app.component('TemplateDesignFormReceipt', templateDesignFormReceipt);
  app.component('TemplateDesignFormReceiptMLNS', templateDesignFormReceiptMLNS);

  //Thiết kế mẫu B103
  app.component('TemplateDesignForm103', templateDesignForm103);
  //Thiết kế mẫu B105
  app.component('TemplateDesignForm105', templateDesignForm105);
  app.component('TemplateDesignFormB113', templateDesignFormB113);
  app.component('TemplateDesignFormB114', templateDesignFormB114);
  app.component('TemplateDesignFormB115', templateDesignFormB115);
  app.component('TemplateDesignFormB116', templateDesignFormB116);
  app.component('TemplateDesignFormB117', templateDesignFormB117);
  //Thiết kế mẫu B118
  app.component('TemplateDesignFormB118', templateDesignFormB118);
  app.component('TemplateDesignForm_B62', templateDesignForm_B62);
  app.component('TemplateDesignFormC402', templateDesignFormC402);
  app.component('TemplateDesignFormC202', templateDesignFormC202);
  app.component('PaymentVoucherListExpensesPaid', PaymentVoucherListExpensesPaid);
}
